import { FC, Fragment, useEffect, useState } from 'react';
import { useLazyQuery } from '@apollo/client';
import { GET_HOUSEHOLD_MEMBERS } from '../../../../../graphql';
import { Accordion, Table } from '../../../../../components/shared';

export type HouseholdMembersCardPropsType = {
  householdId?: string;
  personId?: string;
  privateToOrganisation?: boolean;
};

const HouseholdMembersCard: FC<HouseholdMembersCardPropsType> = props => {
  const { householdId, personId, privateToOrganisation } = props;
  const [members, setMembers] = useState<[{ id: string }] | any>([]);
  const [pages, setPages] = useState(1);

  const [fetchHouseholdMembers, { data, fetchMore, loading }] = useLazyQuery(GET_HOUSEHOLD_MEMBERS, {
    variables: {
      input: {
        householdId,
        personId,
        privateToOrganisation,
        first: 5,
      },
    },
  });

  useEffect(() => {
    if (householdId) {
      fetchHouseholdMembers({ variables: { input: { householdId, personId, privateToOrganisation, first: 10 } } });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [householdId, privateToOrganisation, personId]);

  useEffect(() => {
    if (data && data.members && data.members.edges) {
      setMembers(data.members.edges);
    }

    if (data && data.members && data.members.aggregate) {
      setPages(Math.ceil(data.members.aggregate.count / data.members.edges.length));
    }
  }, [data]);

  const COLUMNS = [
    {
      id: 'name',
      Header: 'Name',
      accessor: ({ node }: any) => (
        <div>{`${node.firstName ? node.firstName : ''}  ${node.lastName ? node.lastName : ''}`}</div>
      ),
    },
    {
      id: 'id',
      Header: 'ID',
      accessor: ({ node }: any) => <div>{node.nationalID || node.passportNumber}</div>,
    },
    {
      id: 'caseId',
      Header: 'Case ID',
      accessor: ({ node }: any) => <div>{node.caseId}</div>,
    },
    {
      id: 'householdId',
      Header: 'Household ID',
      accessor: ({ node }: any) => <div>{node.householdId}</div>,
    },
  ];

  return (
    <Fragment>
      <Accordion key={'householdMembers'} title={`Household Members (${members.length})`}>
        <Table
          defaultPageSize={5}
          padding={0}
          showHeader={false}
          hideActionButton={true}
          columns={COLUMNS}
          pages={pages}
          data={members}
          loading={loading}
          onFetchData={(state: any, instance: any) => {
            fetchMore &&
              fetchMore({
                variables: {
                  input: {
                    first: state.pageSize,
                    skip: state.page * state.pageSize,
                    householdId,
                    personId,
                    privateToOrganisation,
                  },
                },
              }).then(({ data }: any) => {
                if (data && data.members && data.members.edges) {
                  setMembers(data.members.edges);
                }

                if (data && data.members && data.members.aggregate) {
                  setPages(Math.ceil(data.members.aggregate.count / data.members.edges.length));
                }
              });
          }}
        />
      </Accordion>
    </Fragment>
  );
};

export default HouseholdMembersCard;
